// TODO: Replace ResidentStatus from @lmc/ts-common with this enum throughout the project (out of this scope for this ticket, replace it just in the files that we modified)
export enum ResidentStatusEnum {
  active = 'active',
  inactive = 'inactive',
  hospitalised = 'hospitalised',
  transferred = 'transferred',
  deceased = 'deceased',
  discharged = 'discharged',
  preAssessment = 'pre-assessment',
  dummy = 'dummy'
}
